import React from "react";
import { Modal } from "../_components";

import { useModal } from "../_contexts";

import { ImageManagerForm } from "./forms";

export function ImageManager({ prevModal }) {
  const { closeModal } = useModal();

  return (
    <Modal
      id="imageManagerModal"
      // backdrop
      title="Images Manager"
      icon="fas fa-images"
      size="xl"
      open
      onClose={() => closeModal()}
      noPadding
      fullSize
    >
      <ImageManagerForm prevModal={prevModal} />
    </Modal>
  );
}
